export const paymentMixin = {
    data() {
        return {
            ref_nr: null,
            sum: null,
            description: null,
            form_validation: false,
            error: false,
            descriptionRules: [
                v => !!v || this.t("Description is required"),
                v => (v && v.length <= 140) || this.t("Description is too long")
            ],
            referenceNumberRules: [
                v => (!v ? true : this.isReferenceNumberValid(v)) || this.t("Invalid reference number"),
                v => (!v ? true : v.length <= 19) || this.t("Reference number is too long")
            ],
            recipientNameRules: [
                v => !!v || this.t("Recipient name is required")
            ],
            recipientIbanRules: [
                v => !!v || this.t("Recipient IBAN is required"),
            ],
        };
    },
    methods: {
        isReferenceNumberValid(incomingReferenceNumber) {
            if (incomingReferenceNumber && incomingReferenceNumber.length > 0 && incomingReferenceNumber.length <= 19) {
                let referenceNumber = incomingReferenceNumber.split("").map(Number);
                let referenceNumberLastDigit = referenceNumber[referenceNumber.length - 1];
                const method = [7, 3, 1];
                let methodIndex = 0;
                let sum = 0;
                let index = referenceNumber.length - 1;
                while (index) {
                    index--;
                    sum += referenceNumber[index] * method[methodIndex];
                    methodIndex++;
                    if (methodIndex > 2) methodIndex = 0;
                }
                let nearest10 = Math.ceil(sum / 10) * 10;
                let lastDigit = nearest10 - sum;
                if (lastDigit === 10) lastDigit = 0;
                return parseInt(referenceNumberLastDigit) === parseInt(lastDigit);
            }
            return true;
        },
        onlyIntegersWithComa($event) {
            let keyCode = $event.keyCode ? $event.keyCode : $event.key;

            if (keyCode < 44 || keyCode === 47 || keyCode === 45 || keyCode > 57) {
                $event.preventDefault();
            }
        },
        onlyIntegers($event) {
            let keyCode = $event.keyCode ? $event.keyCode : $event.key;

            if (keyCode < 47 || keyCode > 57) {
                $event.preventDefault();
            }
        }
    }
};
